import RoleMultiSelectPanelField from '../RoleMultiSelectPanelField';

import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import EntitySelectPillButton from 'components/EntitySelectPillButton';
import WithField from 'components/WithField';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Item, Props } from './types';

import styles from './styles.module.scss';

const MultiSelectRoleField = <T extends FieldValues>(props: Props<T>) => {
    const {
        className = '',
        control,
        isOpen,
        isRequired,
        label,
        name,
        onPanelClose,
        onPanelOpen,
        placeholder,
        ref,
        testId = TEST_ID
    } = props;

    const { ROLES } = useTranslation();

    const { containerRef, handleToggle, isPanelOpen, onChange, value } = useData<T>({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref
    });

    const fieldLabel = label ?? ROLES;
    const hasValue = value && value.length > 0 && value.every(item => item !== null);

    const handleRemove = (itemToRemove: Item) => {
        onChange(value.filter(item => item.value !== itemToRemove.value));
    };

    return (
        <Wrapper
            className={`${styles.wrapper} ${isPanelOpen ? styles.panelOpen : ''} ${className}`}
            ref={containerRef}
            testId={testId}>
            <WithField className={styles.withField} label={fieldLabel}>
                <HorizontalContainer className={styles.pillsContainer}>
                    {hasValue ? (
                        value.map(item => (
                            <EntitySelectPillButton
                                className={styles.entitySelectPillButton}
                                hasValue={true}
                                key={item.value}
                                onClick={handleToggle}
                                onRemove={() => handleRemove(item)}
                                text={item.label ?? ''}
                            />
                        ))
                    ) : (
                        <EntitySelectPillButton
                            className={styles.entitySelectPillButton}
                            hasValue={false}
                            onClick={handleToggle}
                            text={placeholder ?? ROLES}
                        />
                    )}
                </HorizontalContainer>
            </WithField>

            {isPanelOpen && <RoleMultiSelectPanelField onChange={onChange} value={value ?? []} />}
        </Wrapper>
    );
};

export default MultiSelectRoleField;
